import { render, staticRenderFns } from "./affordResults.vue?vue&type=template&id=48f4905b&"
import script from "./affordResults.vue?vue&type=script&lang=js&"
export * from "./affordResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports